import { Component, OnInit, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal-msg',
  templateUrl: './modal-msg.component.html',
  styleUrls: ['./modal-msg.component.scss']
})
export class ModalMsgComponent implements OnInit {

  @Input() ok: {hidden: false, btnClass: '', text: ''};
  @Input() cancel: {hidden: false, btnClass: '', text: ''};
  @Input() text: string;
  @Input() title: string;
  @Input() type: string;
  @Input() html: boolean;

  iconClass: string;

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    switch (this.type.toLowerCase()) {
      case 'info':
        this.iconClass = 'text-info mdi-information-outline';
        break;

      case 'success':
        this.iconClass = 'text-success mdi-check-circle-outline';
        break;

      case 'danger':
        this.iconClass = 'text-danger mdi-close-circle-outline';
        break;

      case 'warning':
        this.iconClass = 'text-warning mdi-alert-circle-outline';
        break;

      case '':
        this.iconClass = '';
        break;

      default:
        console.error('Valor esperado para o modal é de string: info|success|danger|warning|null');
        break;
    }

    if(this.title.trim() === '')
      this.iconClass = this.iconClass + ' mx-auto';
  }

}
